(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["philips-agua-renueva"] && !Shopify.designMode) return;
  try {
    
(() => {
  if (customElements.get('ph-water-campaign')) return;
  class WaterCampaign extends HTMLElement {
    connectedCallback() {
      if (this.abort) return;
      this.abort = new AbortController();
      this.limit = Number(this.dataset.pageSize) || 12;
      queueMicrotask(() => { if (this.isConnected && this.abort) this.init(); });
    }
    disconnectedCallback() {
      this.abort?.abort();
      this.abort = null;
      clearInterval(this.clock);
    }
    init() {
      const signal = this.abort.signal;
      this.addEventListener('submit', e => {
        const form = e.target.closest('.pwr-product-form');
        if (!form) return;
        e.preventDefault();
        e.stopPropagation();
        this.addToCart(form);
      }, { signal });
      this.addEventListener('change', e => {
        if (e.target.matches('[data-variant-select]')) this.selectVariant(e.target);
      }, { signal });
      this.addEventListener('click', e => {
        if (e.target.closest('[data-show-more]')) {
          const cards = this.cards();
          const firstHidden = cards.find(card => card.hidden);
          this.limit += Number(this.dataset.pageSize) || 12;
          this.showCards();
          firstHidden?.querySelector('h3 a')?.focus({ preventScroll: true });
        }
        if (e.target.closest('[data-copy]')) this.copyCoupon();
        const link = e.target.closest('a[href^="#pwr-products-"]');
        if (link) {
          const target = document.getElementById(link.hash.slice(1));
          if (target) {
            e.preventDefault();
            target.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
            target.focus({ preventScroll: true });
          }
        }
      }, { signal });
      const copy = this.querySelector('[data-copy]');
      if (copy && navigator.clipboard?.writeText) copy.hidden = false;
      this.updateClock();
      this.clock = setInterval(() => this.updateClock(), 1000);
      this.sortCards();
      this.showCards();
      this.loadCatalog();
      const bar = this.querySelector('[data-sticky-bar]');
      if (bar) {
        // Hide under native modal dialogs; keep the campaign CTA out of drawers.
        this.modalObserver = new MutationObserver(() => {
          bar.hidden = Boolean(document.querySelector('dialog[open], cart-drawer.active, .drawer.active'));
        });
        document.querySelectorAll('dialog, cart-drawer, .drawer').forEach(modal => {
          this.modalObserver.observe(modal, { attributes: true, attributeFilter: ['open', 'class'] });
        });
        bar.hidden = Boolean(document.querySelector('dialog[open], cart-drawer.active, .drawer.active'));
        signal.addEventListener('abort', () => this.modalObserver.disconnect(), { once: true });
      }
    }
    cards() { return Array.from(this.querySelectorAll('[data-product-card]')); }
    sortCards() {
      const grid = this.querySelector('[data-product-grid]');
      if (!grid) return;
      this.cards().sort((a, b) => Number(b.dataset.price) - Number(a.dataset.price) || a.dataset.productTitle.localeCompare(b.dataset.productTitle, 'es')).forEach(card => grid.append(card));
    }
    showCards() {
      const cards = this.cards();
      cards.forEach((card, index) => { card.hidden = index >= this.limit; });
      const more = this.querySelector('[data-show-more]');
      if (more) more.hidden = cards.length <= this.limit;
      const empty = this.querySelector('[data-empty]');
      if (empty) empty.hidden = cards.length > 0;
    }
    async loadCatalog() {
      const nav = this.querySelector('[data-catalog-pages]');
      const grid = this.querySelector('[data-product-grid]');
      if (!nav || !grid) return;
      let next = nav.dataset.next;
      const status = this.querySelector('[data-catalog-status]');
      const seen = new Set(this.cards().map(card => card.dataset.productId));
      const visited = new Set();
      const fromLaterPage = Number(grid.dataset.currentPage) > 1;
      if (fromLaterPage) {
        const first = new URL(location.href);
        first.searchParams.set('page', '1');
        next = first.href;
      }
      if (!next) { nav.hidden = true; return; }
      status.textContent = this.dataset.loadingCatalog;
      grid.setAttribute('aria-busy', 'true');
      try {
        while (next) {
          const url = new URL(next, location.href);
          if (url.origin !== location.origin || url.pathname !== location.pathname) throw new Error('Unexpected catalog URL');
          url.searchParams.set('section_id', this.dataset.sectionId);
          if (visited.has(url.href)) throw new Error('Repeated catalog page');
          visited.add(url.href);
          const response = await fetch(url, { signal: this.abort.signal, credentials: 'same-origin' });
          if (!response.ok) throw new Error('Catalog unavailable');
          const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
          const root = doc.getElementById(this.id);
          if (!root?.querySelector('[data-product-grid]')) throw new Error('Missing catalog');
          root.querySelectorAll('[data-product-card]').forEach(card => {
            if (seen.has(card.dataset.productId)) return;
            seen.add(card.dataset.productId);
            card.hidden = true;
            grid.append(card);
          });
          next = root.querySelector('[data-catalog-pages]')?.dataset.next;
        }
        this.sortCards();
        this.showCards();
        nav.hidden = true;
        status.textContent = '';
      } catch (error) {
        if (error.name !== 'AbortError') {
          this.sortCards(); this.showCards();
          status.textContent = this.dataset.catalogError;
          nav.hidden = false;
        }
      } finally { grid.removeAttribute('aria-busy'); }
    }
    selectVariant(select) {
      const option = select.selectedOptions[0];
      if (!option) return;
      const card = select.closest('[data-product-card]');
      const available = option.dataset.available === 'true';
      const price = Number(option.dataset.price), compare = Number(option.dataset.compare);
      card.querySelector('[data-price-money]').textContent = option.dataset.money;
      const was = card.querySelector('[data-compare-money]');
      was.textContent = option.dataset.compareMoney;
      was.hidden = compare <= price;
      const badge = card.querySelector('[data-discount]');
      badge.hidden = compare <= price;
      badge.textContent = compare > price ? `−${Math.round((compare - price) * 100 / compare)}%` : '';
      const button = card.querySelector('[data-add-button]');
      button.disabled = !available;
      button.textContent = available ? button.dataset.label : this.dataset.soldOut;
      card.querySelector('[name="quantity"]').value = option.dataset.quantity || '1';
      card.querySelector('.pwr-card-status').textContent = '';
      const img = card.querySelector('.pwr-product-image');
      if (img && option.dataset.image) {
        img.removeAttribute('srcset');
        img.src = option.dataset.image;
      }
      card.querySelectorAll('[data-product-link]').forEach(link => {
        const url = new URL(link.href);
        url.searchParams.set('variant', option.value);
        link.href = url.href;
      });
    }
    async addToCart(form) {
      if (form.dataset.busy === 'true') return;
      const button = form.querySelector('[data-add-button]');
      if (!button || button.disabled) return;
      const card = form.closest('[data-product-card]');
      const status = card.querySelector('.pwr-card-status');
      const select = form.querySelector('select');
      const root = window.Shopify?.routes?.root || '/';
      const formData = new FormData(form);
      const variantId = String(formData.get('id'));
      const quantity = Number(formData.get('quantity')) || 1;
      const dawn = document.querySelector('cart-drawer, cart-notification');
      const isDawn = typeof dawn?.getSectionsToRender === 'function' && typeof dawn?.renderContents === 'function';
      let sectionIds = [];
      if (isDawn) sectionIds = dawn.getSectionsToRender().map(section => section.id);
      else sectionIds = Array.from(document.querySelectorAll('cart-items-component[data-section-id]')).map(item => item.dataset.sectionId);
      sectionIds = [...new Set(sectionIds)].slice(0, 5);
      if (sectionIds.length) formData.set('sections', sectionIds.join(','));
      formData.set('sections_url', location.pathname);
      formData.delete('return_to');
      form.dataset.busy = 'true';
      button.disabled = true;
      button.textContent = this.dataset.adding;
      if (select) select.disabled = true;
      status.textContent = '';
      status.removeAttribute('data-error');
      try {
        // Do not retry a POST automatically: a lost response could otherwise add twice.
        const response = await fetch(`${root}cart/add.js`, { method: 'POST', headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: formData, credentials: 'same-origin' });
        const result = await response.json();
        if (!response.ok || result.status) throw new Error(typeof result.description === 'string' ? result.description : this.dataset.error);
        status.textContent = this.dataset.added;
        const cartLink = document.createElement('a');
        cartLink.className = 'pwr-link'; cartLink.href = `${root}cart`; cartLink.textContent = this.dataset.cartLabel;
        status.append(' ', cartLink);
        // Updating the theme UI is separate from the successful cart mutation.
        try {
          if (isDawn) {
            dawn.setActiveElement?.(button);
            const nativeResult = result.items?.[0] ? { ...result.items[0], sections: result.sections } : result;
            dawn.classList.remove('is-empty');
            if (result.sections && Object.values(result.sections).every(Boolean)) dawn.renderContents(nativeResult);
          } else {
            // Dwell 3.2 / Horizon: same event contract as its native product form.
            this.dispatchEvent(new CustomEvent('cart:update', { bubbles: true, detail: { resource: {}, sourceId: variantId, data: { source: 'product-form-component', productId: card.dataset.productId, itemCount: quantity, sections: result.sections || {} } } }));
          }
          this.dispatchEvent(new CustomEvent('pwr:cart-added', { bubbles: true, detail: { variantId, productId: card.dataset.productId, quantity, response: result } }));
        } catch (_) { /* The item is already in the native cart; the visible link remains usable. */ }
        if (this.dataset.cartMode === 'cart') location.assign(`${root}cart`);
      } catch (error) {
        status.textContent = error instanceof TypeError ? this.dataset.error : error.message;
        status.setAttribute('data-error', '');
      } finally {
        form.dataset.busy = 'false';
        button.disabled = false;
        button.textContent = button.dataset.label;
        if (select) select.disabled = false;
      }
    }
    updateClock() {
      const start = Date.parse(this.dataset.start), end = Date.parse(this.dataset.end), now = Date.now();
      const box = this.querySelector('[data-countdown]');
      if (!Number.isFinite(start) || !Number.isFinite(end) || end <= start) {
        if (box) box.hidden = true;
        return;
      }
      const expired = now >= end;
      if (box) box.hidden = expired;
      if (expired) {
        if (this.dataset.autoExpire === 'true') this.querySelectorAll('[data-pwr-promo]').forEach(el => { el.hidden = true; });
        const status = this.querySelector('[data-campaign-status]');
        status.textContent = this.dataset.ended; status.hidden = false;
        return;
      }
      if (!box) return;
      const label = this.querySelector('[data-clock-label]');
      label.textContent = now < start ? this.dataset.upcoming : this.dataset.active;
      const remaining = Math.max(0, Math.floor(((now < start ? start : end) - now) / 1000));
      const parts = { days: Math.floor(remaining / 86400), hours: Math.floor(remaining / 3600) % 24, minutes: Math.floor(remaining / 60) % 60, seconds: remaining % 60 };
      for (const [part, value] of Object.entries(parts)) this.querySelector(`[data-time="${part}"]`).textContent = String(value).padStart(2, '0');
    }
    async copyCoupon() {
      const text = this.querySelector('[data-coupon]').textContent.trim();
      const status = this.querySelector('[data-copy-status]');
      try { await navigator.clipboard.writeText(text); status.textContent = this.querySelector('[data-copy]').dataset.copied; }
      catch (_) { status.textContent = text; }
    }
  }
  customElements.define('ph-water-campaign', WaterCampaign);
})();

  } catch(e) { console.error(e); }
})();
})();
